import {Action} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {EntityGrupoUsuario} from './entity-grupo-usuario.model';
import * as Actions from './entity-grupo-usuario.actions';
import {ActionsExample, entityReducer, initial} from '~utils/ngrx-util';

export const entityGrupoUsuarioFeatureKey = 'entityGrupoUsuario';

export interface State extends EntityState<EntityGrupoUsuario> {
}

export const adapter: EntityAdapter<EntityGrupoUsuario> = createEntityAdapter<EntityGrupoUsuario>();

export const initialState: State = adapter.getInitialState(initial);

const entityActions: ActionsExample<EntityGrupoUsuario> = {
  add: Actions.addEntityGrupoUsuario,
  adds: Actions.addEntityGrupoUsuarios,
  clear: Actions.clearEntityGrupoUsuario,
  remove: Actions.deleteEntityGrupoUsuario,
  removes: Actions.deleteEntityGrupoUsuarios,
  load: Actions.loadEntityGrupoUsuario,
  update: Actions.updateEntityGrupoUsuario,
  updates: Actions.updateEntityGrupoUsuarios,
  upsert: Actions.upsertEntityGrupoUsuario,
  upserts: Actions.upsertEntityGrupoUsuarios,
};

const entityGrupoUsuariouracaoReducer = entityReducer(initialState, entityActions, adapter);

export function reducer(state: State | undefined, action: Action): State {
  return entityGrupoUsuariouracaoReducer(state, action);
}

export const {selectIds, selectEntities, selectAll, selectTotal} = adapter.getSelectors();


